import type { FC } from 'react';
import { Button, FunctionCard, SkeletonAvatar, SkeletonLine } from '@george-labs.com/design-system';
import classnames from 'classnames';

const DEFAULT_NUMBER_OF_BUTTONS = 1;

type NumberOfButtons = 0 | 1 | 2 | 3;

interface Props {
    className?: string;
    numberOfButtons?: NumberOfButtons;
    horizontal?: boolean;
    'data-cy'?: string;
}

export const FunctionCardSkeleton: FC<Props> = ({
    className,
    numberOfButtons = DEFAULT_NUMBER_OF_BUTTONS,
    horizontal = true,
    'data-cy': dataCy,
}) => (
    <FunctionCard
        className={className}
        icon={<SkeletonAvatar size={SkeletonAvatar.SIZE.SIZE_64} animated />}
        buttons={[...Array(numberOfButtons).keys()].map((i) => (
            <Button
                key={`function-card-skeleton-button-${i}`}
                className={classnames({ 'w-25': !horizontal })}
                labelClassName="w-75"
                variant={Button.VARIANT.SECONDARY}
                disabled
            >
                <SkeletonLine level={4} animated percentageWidth={100} />
            </Button>
        ))}
        horizontal={horizontal}
        data-cy={dataCy}
    >
        <SkeletonLine percentageWidth={50} level={3} animated className="mb-1" />
        <SkeletonLine percentageWidth={100} level={5} animated />
        <SkeletonLine percentageWidth={100} level={5} animated />
        <SkeletonLine percentageWidth={40} level={5} animated />
    </FunctionCard>
);
